import React, { useEffect, useMemo, useState } from 'react'
import { AlertType, DadosRelDiaCtaPagar, ItensVendas, RetAPI, VendasRelatorio, bgLineGridColorDark, bgLineGridColorLight, contaAPagar, corBgGrid } from '../../Utils/Types'
import { createTheme, ThemeProvider } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { ContaAPagarService } from '../../Pages/ContasAPagar/ContaAPagarService'
import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import moment from 'moment'
import { IoCreate, IoTrash } from 'react-icons/io5'
import { Funcoes } from '../../Utils/Funcoes'
import { Link } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'

type Props = {
    resumoPorGrupo: any[],
}

interface RowData {

    desc_prod: string,
    id_produto: number,
    tqtde: number,
    tliquido: number,
    descricao: string

}

type VisibilityState = Record<string, boolean>

export const GridResumoPorGrupo = React.memo(({ resumoPorGrupo }: Props) => {

    const xJson = localStorage.getItem("@commerce/column_grid_resumo_por_grupo")

    let json: any = {
        desc_prod: true,
        id_produto: true,
        tqtde: true,
        tliquido: true,
        descricao: true
    }

    if (xJson) {
        json = JSON.parse(localStorage.getItem("@commerce/column_grid_resumo_por_grupo") || '')
    }

    //const [feedBackVisible, setFeedBackVisible] = useState(false)
    //const [messageFeedBack, setMessageFeedBack] = useState("")
    //const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(json)

    let user = useSelector(state => selectUser(state))

    const theme = createTheme({
        palette: {
            mode: user.modeDark,

            background: {
                default:
                    user.modeDark === 'light'
                        ? '#fff' // modo claro
                        : '#475569', //modo escuro
            },
        },
    })

    useEffect(() => {

        if (xJson) {

            if (json) {
                const newColumnVisibility: VisibilityState = { ...columnVisibility }
                newColumnVisibility.desc_prod = json.desc_prod
                newColumnVisibility.id_produto = json.id_produto
                newColumnVisibility.tqtde = json.tqtde
                newColumnVisibility.tliquido = json.tliquido
                newColumnVisibility.descricao = json.descricao
            }
        }
    }, [])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_resumo_por_grupo", JSON.stringify(columnVisibility))
    }, [columnVisibility])

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'

    const colunas = useMemo<MRT_ColumnDef<any>[]>(
        () => [

            {
                accessorKey: 'desc_prod', header: 'Descrição do Produto', size: 400, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.desc_prod ? rowData.desc_prod : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'descricao', header: 'Descrição do Grupo', size: 400, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.descricao ? rowData.descricao : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'tqtde', header: 'Quantide de Itens', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.tqtde ? Funcoes.numberFormat(rowData.tqtde, 'decimal') : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'tliquido', header: ' Valor Líquido', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.tliquido ? Funcoes.numberFormat(rowData.tliquido, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)
                    
                }
            },

        ], []
    )

    const table = useMaterialReactTable({
        columns: colunas,
        data: resumoPorGrupo,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: false,
        enableColumnFilters: false,
        enableHiding: false,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (
        <>

            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>

        </>
    )

})